import ShipmentStatus from './shipmentTracking';
import CollapsibleProductLineList from './collapsibleProductLineList';
import React from 'react';
import {
    Card,
    CardHeader,
    CardContent,
    Typography,
} from '@toppy-webshop/toppy-design-system';
import PostNLLogo from '../../assets/images/icons/carrier/postnl.svg';
import RabenLogo from '../../assets/images/icons/carrier/raben.svg';
import {Shipment} from '../../models/shipment';
import {useI18nContext} from '../../i18n/i18n-react';

interface PackageStatusOverviewProps {
    shipment: Shipment;
    shipmentIndex: number;
    totalShipmentCount: number;
}

const ShipmentCard = ({
    shipment,
    shipmentIndex,
    totalShipmentCount,
}: PackageStatusOverviewProps) => {
    const {LL} = useI18nContext();
    return (
        <Card>
            <CardHeader>
                <Typography
                    variant="h6"
                    component={'span'}
                    lineHeight={'tight'}
                    noMargin
                >
                    {shipment.items[0].isBackorder
                        ? LL.backorder.title()
                        : LL.shipment.title({
                              index: shipmentIndex + 1,
                              count: totalShipmentCount,
                          })}{' '}
                </Typography>
                {!shipment.isDelivered && shipment.tracks.length > 0 && (
                    <img
                        src={
                            -1 !==
                            shipment.tracks[0].carrier
                                .toLowerCase()
                                .indexOf('raben')
                                ? RabenLogo
                                : PostNLLogo
                        }
                        alt="PostNL"
                        style={{maxHeight: '32px', float: 'right'}}
                    />
                )}
            </CardHeader>
            <CardContent>
                <ShipmentStatus shipment={shipment} />
            </CardContent>
            <CollapsibleProductLineList
                products={shipment.items.map((item, index) => ({
                    key: index.toString(),
                    name: item.description,
                    qty: item.qty,
                }))}
            />
        </Card>
    );
};

export default ShipmentCard;
